import React, { useState } from 'react';
import { createBrowserRouter, Outlet, BrowserRouter as Router, RouterProvider } from 'react-router-dom';
import './styles/animation.css';
import './styles/BackToTop.css';
import Navbar from './components/layout/Navbar';
import NavTest from './components/NavTest';
import Footer from './components/layout/Footer';
import LandingPage from './page/LandingPage';
import About from './components/about/About';
import Infos from './components/infos/Infos';
import RegisterBtn from './components/RegisterBtn';
import QuizzBtn from './components/QuizzBtn';
import Denonciation from './components/denonciation/denonciation';
import { CustomToast } from './composants/toast/CustomToast';
import Register from './components/register/register';
import ListArticles from './components/articles/list/listArticles';
import ReadArticles from './components/articles/read/readArticles';
import QuestionScreen from './components/quizz/question-screen/index';
import Usraj from './components/usraj/usraj';
import Services from './components/service/services';
import CarteLeaflet from './components/carte/carteLeaflet';
import Background from './composants/background/background';
import CustomFlagButton from './components/customFlagButton/customFlagButton';
import { LoadingContext } from './composants/loadingContext';
import { Result } from 'antd';
import Gallery from "./components/gallery/gallery";
import { ColorsContext } from './composants/colorContext';
import Partenaires from './page/partenaire/Partenaires';
import NavTestNew from './components/NavTestNew';
import ListAlert from './components/alert/list/ListAlert';
import ViewWeather from './components/weather/list/ViewWeather';
import AllArticles from './components/articles/all/allArticles';


function App() {
    const route = createBrowserRouter([
        {
            path: '/',
            element: <Root />,
            errorElement: <Error />,
            children: [
                {
                    path: '',
                    element: <LandingPage />
                },
                {
                    path: 'denonciation',
                    element: <Denonciation />
                },
                {
                    path: 'about',
                    element: <About />
                },
                {
                    path: 'infos/:id',
                    element: <Infos />
                },
                {
                    path: 'register',
                    element: <Register />
                },
                {
                    path: 'articles/:name',
                    element: <ListArticles />
                },
                {
                    path: 'all/articles',
                    element: <AllArticles />
                },
                {
                    path: 'alert/all',
                    element: <ListAlert />
                },
                {
                    path: 'gallery',
                    element: <Gallery />
                },
                {
                    path: 'partenaires',
                    element: <Partenaires />
                },
                {
                    path: 'article/:id',
                    element: <ReadArticles />
                },
                {
                    path: 'sondage/:id',
                    element: <QuestionScreen />
                },
                {
                    path: 'usraj/:id',
                    element: <Usraj />
                },
                {
                    path: 'service',
                    element: <Services />
                },
                {
                    path: 'usraj/location',
                    element: <div style={{ paddingTop: 52 }}><CarteLeaflet /></div>
                },
                {
                    path: '*',
                    element: <ErrorPage />
                }
            ]
        },
    ]);
    function Root() {
        const [loading, setLoading] = useState(true);
        const valueLoading = {
            loading: loading,
            setLoading: setLoading
        };
        const [colors, setColors] = useState({
            COLOR_BODY: localStorage.getItem('COLOR_BODY') || '#ffffffff',
            COLOR_HEADER: localStorage.getItem('COLOR_HEADER') || '#ffffffff',
            COLOR_NAVBAR: localStorage.getItem('COLOR_NAVBAR') || '#ffffffff'
        });
        const valueColors = {
            colors: colors,
            setColors: setColors
        }
        return (
            <ColorsContext.Provider value={valueColors}>
                <LoadingContext.Provider value={valueLoading}>
                    <div className="min-h-screen flex flex-col">
                        <Background />
                        <NavTestNew />
                        <RegisterBtn />
                        <QuizzBtn />
                        <div style={{ backgroundColor: colors.COLOR_BODY }} className="flex-grow">
                            <Outlet />
                            <CustomToast />
                        </div>
                        <CustomFlagButton />
                        <Footer />
                    </div>
                </LoadingContext.Provider>
            </ColorsContext.Provider>
        );
    }
    function ErrorPage() {
        return (
            <div style={{ paddingTop: 52 }}>
                <Result
                    status="404"
                    title="404"
                    subTitle="Page not found"
                />
            </div>
        );
    }
    function Error() {
        return (
            <div className="min-h-screen flex flex-col">
                <Background />
                <Navbar />
                <RegisterBtn />
                <QuizzBtn />
                <div className="flex-grow">
                    <ErrorPage />
                </div>
                <Footer />
            </div>
        );
    }



    return <RouterProvider router={route} />;
}

export default App;




/*function App() {
  return <RouterProvider router={route} />;
}
export default App;*/

// Dans votre configuration de route, ajoutez :

